import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigNumberColumn} from '@src/@interfaces/components/List/IListConfigNumberColumn';
import sprintf from '@src/helpers/numbers/sprintf';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';

export default class NumberColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigNumberColumn>, Model> {
    protected get value(): any {
        const value = super.value;
        if (value == null) {
            return null;
        }

        return sprintf(this.config.format ?? '%s', value);
    }
}
